import { actionPlanFetch } from "../../../../../../../utils/constants/callService"

const downloadReportUrl = async ({ url, id }: { url?: string | null; id?: string }) => {
    if (!url) {
        if (id) {
            const reponseUrlReport = await actionPlanFetch.generateReport(id)
            window.open(reponseUrlReport.urlToReport, 'target')
            if (!!reponseUrlReport.errors) {
                return { response: false }
            }
        }
    } else {
        window.open(url as string, 'target')
    }
    return { response: true }
}

export { downloadReportUrl }